module.exports = __webpack_public_path__ + "static/media/over256.cb371926.png";